import { apiService } from "../axiosService";

export const getMonitorLogs = async (orgId, filters) => {
  const response = await apiService.get(`/organisations/${orgId}/monitor`, { params: filters });
  return response;
};

export const getUserLogs = async (filters) => {
  const response = await apiService.get(`/monitor/user-logs`, { params: filters });
  return response;
};

export const getUserServiceUsers = async (filters) => {
  const response = await apiService.get(`/user-services/users`, { params: filters });
  return response;
};

export const getLogById = async (orgId, logId) => {
  const response = await apiService.get(`/organisations/${orgId}/monitor/${logId}`);
  return response;
};
